import { render } from "./BDMDetailsDashboard.vue?vue&type=template&id=443d2fdb&scoped=true"
import script from "./BDMDetailsDashboard.vue?vue&type=script&lang=js"
export * from "./BDMDetailsDashboard.vue?vue&type=script&lang=js"

import "./BDMDetailsDashboard.vue?vue&type=style&index=0&id=443d2fdb&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443d2fdb"]])

export default __exports__